import React from "react";

export default function Message({ message, src, onClick }) {
  return (
    <main className="message">
      <div className="message__img">
        <img src={`img/${src}.png`} alt="DrugVokrug" />
      </div>
      <p className="message__text">{message}</p>
      <button className="btn btn-success message-button" onClick={onClick}>
        Вернуться
      </button>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/Message.js